import { ColDef } from 'ag-grid-community';
import { IndigoAppContextType } from 'app/AppContext';
import {
    toNumericColDef,
    toPercentColDef,
    toColDef,
} from '@instinet-analytics/semantic-ui-components';

export type PortfolioSummaryColumn =
    | 'groupName'
    | 'count'
    | 'orderQty'
    | 'tradedQty'
    | 'leavesQty'
    | 'orderedValueLoc'
    | 'tradedValueLoc'
    | 'leavesValueLoc'
    | 'netOrderedValueLoc'
    | 'netTradedValueLoc'
    | 'netLeavesValueLoc'
    | 'averagePercentageCompletion';

export function portfolioSummaryColumnDefinitions(
    context: IndigoAppContextType,
    headerText: string,
    aggregationField: string
): ColDef[] {
    const includeNetFields = aggregationField !== 'side';

    const ret = [
        toColDef(context, 'groupName', {
            headerName: headerText,
            textAlign: 'left',
        }),
        toNumericColDef(context, 'count', { headerName: 'Num' }),
        toNumericColDef(context, 'orderQty', { headerName: 'Order Qty' }),
        toNumericColDef(context, 'tradedQty', { headerName: 'Traded Qty' }),
        toNumericColDef(context, 'leavesQty', { headerName: 'Leaves Qty' }),
        toNumericColDef(context, 'orderedValueLoc', {
            headerName: context.currencyFormat.prefix + ' Ordered',
            valuePrefix: context.currencyFormat.prefix,
        }),
        toNumericColDef(context, 'tradedValueLoc', {
            headerName: context.currencyFormat.prefix + ' Traded',
            valuePrefix: context.currencyFormat.prefix,
        }),
        toNumericColDef(context, 'leavesValueLoc', {
            headerName: context.currencyFormat.prefix + ' Leaves',
            valuePrefix: context.currencyFormat.prefix,
        }),
        includeNetFields
            ? toNumericColDef(context, 'netOrderedValueLoc', {
                  headerName: context.currencyFormat.prefix + ' Net Ordered',
                  valuePrefix: context.currencyFormat.prefix,
              })
            : undefined,
        includeNetFields
            ? toNumericColDef(context, 'netTradedValueLoc', {
                  headerName: context.currencyFormat.prefix + ' Net Traded',
                  valuePrefix: context.currencyFormat.prefix,
              })
            : undefined,
        includeNetFields
            ? toNumericColDef(context, 'netLeavesValueLoc', {
                  headerName: context.currencyFormat.prefix + ' Net Leaves',
                  valuePrefix: context.currencyFormat.prefix,
              })
            : undefined,

        toPercentColDef(context, 'averagePercentageCompletion', {
            headerName: '%Comp',
            dps: 1,
        }),
    ];

    return ret.filter((r) => !!r) as ColDef[];
}
